<template>
  <div>
    <TempPageVue>
      <template v-slot:left>
        <div class="col-lg-3">
          <UserFeedInfoVue ref="userFeed" :props_selectItem="pageData.sgL_Type == 0 ? 'FeedCloud' : 'feed'">
          </UserFeedInfoVue>
        </div>
      </template>
      <template v-slot:content>
        <div class="col-lg-6 px-lg-2 pool-fm">
          <div class="row">
            <!-- 排序按鈕 -->
            <!-- <div class="sorting-fm col-12"></div> -->
            <!-- ./上傳影片按鈕 -->
            <!-- 影片一覽 Post -->
            <div class="pool-fm pb-5">
              <div class="pool-cloud">
                <div class="video">
                  <img class="feedImg" v-if="pageData.sgL_Type == 1 && !IsNullOrEmpty(pageData.sgL_ImageTempURL)"
                    :src="pageData.sgL_ImageTempURL" />
                  <div class="group_mulit-photo"
                    v-else-if="pageData.sgL_Type == 1 && !IsNullOrEmpty(pageData.sgL_GroupImageTemplS)">
                    <img class="mu_photo" :src="ig" v-for="(
                                          ig, ix
                                        ) in pageData.sgL_GroupImageTemplS" @click="showImg(pageData, ix)" :key="ix" />
                  </div>
                  <!-- <video v-else class="cloud-video-steam" controls="" controlsList="nodownload" v-watermark preload="metadata" playsinline=""
                    :poster="
                      IsNullOrEmpty(pageData.sgL_ImageTempURL)
                        ? pageData.jietuFileUrl
                        : pageData.sgL_ImageTempURL
                    " :src="`${pageData.fileShareUrl}${addT}`"></video> -->

                  <video-player v-else-if="pageData.sgL_Type == 0" class="video-player vjs-custom-skin"
                    :playsinline="true" preload="auto" v-watermark :options="playerOption_"
                    @play="onPlayerPlay($event, pageData.id)"></video-player>


                </div>
                <cloubToolVue :likeNum="pageData.sgL_PG_CTotalLike"
                  @like="$parent.likeFunc(pageData, pageData.sgL_IsLike)" :showDetail="false" :showViewData="false"
                  class="white toolSize">
                  <template v-slot:menu>
                    <moreMenuVue @ck="$parent.copyLink(pageData.id)">
                      <template v-slot:icon>
                        <i class="fa fa-clone mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.DisplayVideo.clone') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.collectFunc(pageData)">
                      <template v-slot:icon>
                        <i v-if="pageData.sgL_IsFavorite" class="fas fa-bookmark fa-fw"></i>
                        <i v-else class="far fa-bookmark mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.DisplayVideo.bookmark') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.updateStatistics(pageData, 50)">
                      <template v-slot:icon>
                        <i class="fa fa-clone mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.DisplayVideo.share') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.reportFunc(pageData)">
                      <template v-slot:icon>
                        <i class="far fa-flag mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.DisplayVideo.flag') }} </template>
                    </moreMenuVue>
                  </template>
                </cloubToolVue>
                <cloubDetailVue :avatar="pageData.userLogoBig" :title="pageData.sgL_Title"
                  :authorName="pageData.sgL_MyVideoName" :displayName="pageData.sgL_UsersName"
                  :lookCount="pageData.sgL_PG_CTotalView" :date="pageData.sgL_PG_CAddTimerI" :userId="pageData.sgL_UserID"
                  class="white ptrl-1imp"></cloubDetailVue>
                <div class="feedpost-ensize">
                  <div class="feedpost-head white pb-3">
                    <div class="feedpost-content">
                      <p>
                        {{ pageData.sgL_Content }}
                      </p>
                    </div>
                    <div class="feedpost-content" v-if="keyWord != ''">
                      <p> {{ $t('Social.DisplayVideo.keyWord') }}:</p>
                      <span>{{ keyWord }}</span>
                    </div>
                    <input class="form-control" type="text" :placeholder="$t('Social.DisplayVideo.placeholder')"
                      v-model="commentText" @keydown="key($event, pageData)" />
                  </div>
                </div>
                <div class="feedpost-comment-list">
                  <div class="comment" v-for="item in commentData" :key="item.id">
                    <div class="comment-left mr-2">
                      <a href="javascript:void(0);">
                        <img class="user-logo" :src="item.sgL_ImageLogin" :onerror="$defaultUserLog" />
                      </a>
                    </div>
                    <div class="comment-right" style="flex: 1">
                      <span class="feedpost-user">
                        <a href="javascript:void(0);">
                          {{ item.sgL_Mem_DisplayName }}
                        </a>
                      </span>
                      <span class="comment-content">
                        {{ item.sgL_Msg_MContent }}
                        <a href="javascript:" style="font-size: 12px" @click="commentShowIds = item.id"> {{
                          $t('Social.DisplayVideo.recover') }}</a>
                        <deleteCommentVue style="font-size: 12px" :commentId="item.id" :authId="item.sgL_Mem_Cid"
                          @delSuccess="getCommentData(pageData.id, pageData.sgL_GroupId)"></deleteCommentVue>
                      </span>
                      <span class="publish-time">
                        {{ item.sgL_My_Receive_MViewTimersI }}
                      </span>
                      <div v-show="commentShowIds === item.id">
                        <input class="form-control form-control-sm" type="text"
                          :placeholder="$t('Social.DisplayVideo.placeholder2')" v-model="commentText2"
                          @keydown="key2($event, pageData, item)" />
                      </div>
                      <div v-for="comments in item.messageDto" style="margin-top: 10px" :key="comments.id">
                        <div style="display: flex">
                          <a href="javascript:void(0);">
                            <img class="user-logo" :src="comments.sgL_ImageLogin" alt="user-icon"
                              :onerror="$defaultUserLog" />
                          </a>
                          <div style="flex: 1; display: flex;flex-direction: column;margin-left: 5px;">
                            <div>
                              <span class="feedpost-username">
                                <a href="javascript:void(0);">
                                  {{ comments.sgL_Mem_DisplayName }}
                                </a></span>
                            </div>
                            <div>
                              <span class="publish-time">
                                {{ comments.sgL_Msg_MAddTimerI }}
                              </span>
                            </div>
                            <div>
                              <span class="comment-content">
                                {{ comments.sgL_Msg_MContent }}
                                <deleteCommentVue style="font-size: 12px" :commentId="comments.id"
                                  :authId="comments.sgL_Mem_Cid"
                                  @delSuccess="getCommentData(pageData.id, pageData.sgL_GroupId)">
                                </deleteCommentVue>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:right>
        <div class="hit-playcount col-lg-3" v-if="pageData.sgL_Type == 0">
          <span class="title ptrl-1">
            <i class="fa fa-bullhorn pl-3"></i> {{ $t('Social.DisplayVideo.hit') }}
          </span>
          <div class="playcount-info" v-for="(item, index) in rightData" :key="item.id">
            <router-link :to="{ name: 'DisplayVideo', query: { id: item.id } }">
              <div class="Ranking">
                <span :class="`sh-${index + 1}`">{{ index + 1 }}</span>
              </div>
              <a href="javascript:void(0);" class="playcount-photo" :style="{
                backgroundImage: 'url(' + `${item.userLogoSmail}` + ')',
              }"></a>
              <span class="playcount-vname">{{ item.sgL_MyVideoName }}</span>
              <HeartVue @like="$parent.likeFunc(item, item.sgL_IsLike)">
                <template v-slot:count>
                  <span>{{ item.sgL_PG_CTotalLike }}</span>
                </template>
              </HeartVue>
              <videoVue :id="item.id" :url="item.fileShareUrl" :poster="item.sgL_ImageTempURL"
                :poster2="item.jietuFileUrl">
              </videoVue>
            </router-link>
          </div>
        </div>
      </template>
    </TempPageVue>
    <groupImgVue ref="groupImgVue" />
  </div>
</template>

<script>
// import shareVue 
import TempPageVue from "./TempPage.vue";
import UserFeedInfoVue from "./UserFeedInfo.vue";
import bases from "../../api/httpApi/base";
import moreMenuVue from "./moreMenu.vue";
import videoVue from "./video.vue";
import cloubDetailVue from "./cloubDetail.vue";
import cloubToolVue from "./cloubTool.vue";
import HeartVue from "./Heart.vue";
import deleteCommentVue from "../common/deleteComment.vue";
import socialTool from "../../assets/js/socialJs/tool";
import groupImgVue from "@/components/Social/group/groupImg.vue";
export default {
  components: {
    TempPageVue,
    UserFeedInfoVue,
    moreMenuVue,
    videoVue,
    cloubDetailVue,
    cloubToolVue,
    HeartVue,
    deleteCommentVue,
    groupImgVue,
  },
  created () {
    let query = this.$route.query;
    this.getData(query.id);
    this.getRightData();
  },
  mounted () {
  },
  data () {
    return {
      pageData: {},
      rightData: [],
      commentData: {},
      commentText: "",
      keyWord: "",
      addT: "",
      currentPlayer: null,
      commentShowIds: -1,
      commentText2: "",
      playerOption: {},
      playerOption_: {},
      noChangeVideoList: [],
    };
  },
  methods: {
    showImg (item, ix) {
      this.$refs.groupImgVue.setData(item.sgL_GroupImageTemplP, ix);
      this.$refs.groupImgVue.showWindow();
    },
    onPlayerPlay (player, index) {
      if (this.currentPlayer && this.currentPlayer != player) {
        this.currentPlayer.pause();
      }
      this.currentPlayer = player;
    },
    getRightData () {
      let params = {
        SGL_IsShow: 1,
        SGL_Type: 0,
        Sorting: "QueriesCount",
        SkipCount: 0,
        MaxResultCount: 5,
      };
      this.$api.social.GetSocialData(params).then((res) => {
        if (res.data.success) {
          this.rightData = res.data.result.items;
        } else {
          //this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    getData (id) {
      // console.log(this.$route.from);
      this.$parent.getSingleData(id).then((data) => {
        this.pageData = data;
        this.getCommentData(this.pageData.id, this.pageData.sgL_GroupId);
        this.setPlayerVideo(this.pageData);
        if (this.pageData) {
          this.addT =
            this.IsNullOrEmpty(this.pageData.sgL_ImageTempURL) &&
              this.IsNullOrEmpty(this.pageData.jietuFileUrl)
              ? "#t=0.5"
              : "";
        }
        if (!this.IsNullOrEmpty(this.pageData.sgL_Keyworld)) {
          let keyList = this.pageData.sgL_Keyworld.split(",");
          for (let i in keyList) {
            this.keyWord += "#" + keyList[i];
          }
        }
      });
    },
    copy () { },

    setPlayerVideo (item) {
      socialTool.setPlayer(
        this.playerOption,
        this.noChangeVideoList,
        item.id,
        item.fileShareUrl,
        // item.fileUrl,
        false,
        this.IsNullOrEmpty(item.sgL_ImageTempURL)
          ? item.jietuFileUrl
          : item.sgL_ImageTempURL
      );
      this.playerOption_ = this.playerOption[item.id];
    },

    getCommentData (id, sgL_GroupId) {
      this.$parent.qryComment({ id: id, sgL_GroupId: sgL_GroupId }).then((data) => {
        this.commentData = data;
      });
    },
    key (event, item) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        this.$parent.submitComment(item, this.commentText, this.keyCallBack);
      }
    },
    key2 (event, item, comment) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13 && !this.isCanEntry2) {
        this.isCanEntry2 = true;
        this.$parent.submitComment2(
          item,
          this.commentText2,
          this.keyCallBack,
          this.commentShowIds,
          comment.sgL_Mem_Reply_Cid
        );
      }
    },
    keyCallBack () {
      this.commentText = "";
      this.commentText2 = "";
      this.getCommentData(this.pageData.id, this.pageData.sgL_GroupId);
    },
  },
};
</script>

<style scoped>
.feedpost-comment-list .comment+.comment {
  border-top: 1px solid #ececec;
}

.user-logo2 {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  vertical-align: middle;
}

.cloud-info {
  width: 100%;
}

.pool-cloud {
  width: 100%;
}

.playcount-info>>>.cloud-video-fm {
  width: 100%;
}

.cloud-video-steam {
  /* object-fit: fill; */
  width: 100%;
  background-color: black !important;
}

@media (min-width: 1200px) {
  .cloud-video-steam {
    height: 300px !important;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .cloud-video-steam {
    height: 250px !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .cloud-video-steam {
    height: 380px !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .cloud-video-steam {
    height: 300px !important;
  }
}

@media (max-width: 575px) {
  .cloud-video-steam {
    height: 250px !important;
  }
}

.toolSize>>>.cloud-more {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/DisplayVideo.vue